import { useContext } from 'react';
import { ExerciseTranslationsContext } from '../../contexts/ExerciseTranslationsContext';
import { ExerciseResult } from '../../@types/exercise-types';
import { useExerciseManagerContext } from '../../contexts/ExerciseManagerContext';
import Dialog from '@pelckmans/elementis/components/dialog';
import Button from '@pelckmans/elementis/components/button';
import ExerciseHighLightedItem from '../exercise-highlighted-item';

export type LaunchModalCompletedSessionProps = {
  onReview: (sessionId: string) => void;
  onRestart?: () => void;
  result: ExerciseResult;
};

function LaunchModalCompletedSession({ onReview, onRestart, result }: LaunchModalCompletedSessionProps) {
  const translations = useContext(ExerciseTranslationsContext);

  const { medialink, module, onClose } = useExerciseManagerContext();

  const { session } = result;

  return (
    <Dialog
      id="launch-modal-completed-session"
      modal
      onClose={onClose}
      aria-label={translations.launchModalCompletedSession.a11yLabel}
    >
      <Dialog.Header
        title={translations.launchModalCompletedSession.title}
        onClose={onClose}
        aria-label={translations.closeDialog}
      />

      <Dialog.Body>
        <div className="modal-content-text">
          <p>
            {onRestart
              ? translations.launchModalCompletedSession.message.restartable
              : translations.launchModalCompletedSession.message.nonRestartable}
          </p>
        </div>
        <ExerciseHighLightedItem
          module={module}
          status={medialink.unachievable ? undefined : 'finished'}
          medialink={medialink}
          title={translations.launchModalCompletedSession.highlightedItem.title}
          scoreTitle={translations.launchModalCompletedSession.highlightedItem.score}
          percentageTitle={translations.launchModalCompletedSession.highlightedItem.percentage}
          result={{
            title: translations.launchModalCompletedSession.highlightedItem.resultTitle,
            score: result.score,
          }}
        />
      </Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsLeft={
          session
            ? {
                'aria-label': undefined,
                role: undefined,
                children: (
                  <Button prominence="neutral" onClick={() => onReview(session)}>
                    {translations.launchModalCompletedSession.buttons.review}
                  </Button>
                ),
              }
            : undefined
        }
        buttonGroupPropsRight={{
          'aria-label': undefined,
          role: undefined,
          children: (
            <>
              <Button onClick={onClose} prominence="neutral" key="cancel">
                {translations.launchModalCompletedSession.buttons.cancel}
              </Button>
              {onRestart && (
                <Button onClick={onRestart} prominence="success" key="success">
                  {translations.launchModalCompletedSession.buttons.restart}
                </Button>
              )}
            </>
          ),
        }}
      />
    </Dialog>
  );
}

export default LaunchModalCompletedSession;
